import styled from 'styled-components';
import { motion } from 'framer-motion';
import fonts from '../../design-system/fonts';
import { colors } from '../../design-system/colors';

export const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: ${colors.porcelain};
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

export const MainContent = styled.main`
  flex: 1;
  padding-top: 120px;
  padding-bottom: 80px;

  @media (max-width: 768px) {
    padding-top: 100px;
    padding-bottom: 60px;
  }
`;

export const ContentSection = styled.section`
  background: ${colors.porcelain};
`;

export const ContentWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const HeaderSection = styled.div`
  /* margin-bottom: 40px; */
`;

export const Title = styled(motion.h1)`
  font-size: 48px;
  font-weight: 800;
  line-height: 1.2;
  color: ${colors.sapphire};
  margin: 0 0 16px 0;
  letter-spacing: -0.02em;
  font-family: ${fonts.headline};

  @media (max-width: 768px) {
    font-size: 36px;
  }
`;

export const Subtitle = styled(motion.p)`
  font-size: 18px;
  line-height: 1.6;
  color: ${colors.deepCharcoal};
  opacity: 0.7;
  font-family: ${fonts.body};
  margin: 0;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const Section = styled(motion.section)`
  background: white;
  padding: 32px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.06);

  @media (max-width: 768px) {
    padding: 24px;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 22px;
  font-weight: 700;
  color: ${colors.deepCharcoal};
  margin: 0 0 20px 0;
  font-family: ${fonts.headline};
  letter-spacing: -0.01em;
  display: flex;
  align-items: center;
  gap: 12px;

  &::before {
    content: attr(data-number);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    background: ${colors.sapphire};
    color: white;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 700;
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    font-size: 20px;
    margin-bottom: 16px;

    &::before {
      width: 24px;
      height: 24px;
      font-size: 12px;
    }
  }
`;

export const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const Paragraph = styled.p`
  font-size: 16px;
  line-height: 1.7;
  color: ${colors.deepCharcoal};
  opacity: 0.8;
  font-family: ${fonts.body};
  margin: 0;

  strong {
    color: ${colors.deepCharcoal};
    opacity: 1;
    font-weight: 600;
  }
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ListItem = styled.li`
  font-size: 16px;
  line-height: 1.7;
  color: ${colors.deepCharcoal};
  opacity: 0.8;
  font-family: ${fonts.body};
  padding-left: 20px;
  position: relative;

  &::before {
    content: '•';
    position: absolute;
    left: 0;
    color: ${colors.sapphire};
    font-weight: 700;
    font-size: 18px;
  }
`;

export const ContactInfo = styled.div`
  font-size: 16px;
  line-height: 1.7;
  color: ${colors.deepCharcoal};
  opacity: 0.9;
  font-family: ${fonts.body};
  margin-top: 8px;
  padding: 20px;
  background: rgba(28, 80, 196, 0.04);
  border-radius: 6px;

  strong {
    color: ${colors.sapphire};
    font-weight: 600;
  }
`;
